import React from 'react';
import PropTypes from 'prop-types';
import { AttributeTable } from '@itds/elements/index.js';

const Lead = ({ lead }) => {
  let formatted_lead;

  if (lead) {
    const { assigned_members, ...other_attr } = lead;

    formatted_lead = {
      ...other_attr,
      members: assigned_members.map(l => `${l.first_name} ${l.last_name}`).join(', ')
    };
  }

  return (
    <AttributeTable
      data={formatted_lead}
      headers={[
        { label: 'Attribute', textAlign: 'right' },
        { label: 'Value', textAlign: 'left' }
      ]}
    />
  );
};

Lead.propTypes = {
  lead: PropTypes.object
};

export default Lead;
